import { connect } from 'react-redux';
import View from './HasHomeownerAssociationFeeView';
import { isPopulatedSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateSupportData, updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import nextIteratorsSelector, {
  yesOrNoHomeownerAssociationFeeSelector,
  alreadyHadAssociationFeeSelector,
} from './HasHomeownerAssociationFeeSelector';
import { hasHomeownerAssociationFeeSelector } from '../HomeownersAssociationFee/HomeownersAssociationFeeSelector';

const mapStateToProps = (state, ownProps) => ({
  workflowId: ownProps.workflowId,
  branch: ownProps.branch,
  hasHomeownerAssociationFee: hasHomeownerAssociationFeeSelector(state, ownProps),
  yesOrNoHomeownerAssociationFee: yesOrNoHomeownerAssociationFeeSelector(state, ownProps),
  alreadyHadAssociationFee: alreadyHadAssociationFeeSelector(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  nextIterators: nextIteratorsSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  preprocessYesOrNoHasHomeownersAssociationFee: (workflowId, hasHomeownerAssociationFee) => {
    if (hasHomeownerAssociationFee) {
      dispatch(updateSupportData(
        {
          [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
            HasHomeownerAssociationFee: true,
            AlreadyHadHomeownerAssociationFee: true,
          },
        },
        workflowId,
      ));
    }
  },
  onChangedYesOrNoHomeownerAssociationFee: workflowId => ({ target: { checked } }) => {
    dispatch(updateSupportData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          HasHomeownerAssociationFee: checked,
        },
      },
      workflowId,
    ));
  },
  onPostProcess: yesOrNoHomeownerAssociationFee => (data) => {
    if (yesOrNoHomeownerAssociationFee === false) {
      return {
        ...data,
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          ...data[HOME_PURCHASE_GOAL_GRAPH_NODE],
          MonthlyHoa: 0,
        },
      };
    }
    return data;
  },
  onPostSave: workflowId => (data) => {
    dispatch(updateData(data, workflowId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
